import { api } from "./api";

export const move = (arr, i, dir) => {
  const j = i + dir;
  if (j < 0 || j >= arr.length) return null;
  const copy = [...arr];
  [copy[i], copy[j]] = [copy[j], copy[i]];
  return copy;
};

export const fileToUrl = (p) => `${api.defaults.baseURL}/files/${p}`;
